window.addEventListener('load', () => {
  const glossarySearchInput = document.querySelector('.glossary-listing-filter .form-item-combine input');

  if (!glossarySearchInput) return;

  if (glossarySearchInput.value !== '') {
    document.querySelector('.clear-glossary-search-results').classList.add('active');
  }
});
